import PropTypes from 'prop-types';

export const CarrierSharingPropType = PropTypes.shape({
  count: PropTypes.number,
  isDefault: PropTypes.bool,
});

export const SelectedServicePropType = PropTypes.shape({
  service: PropTypes.number.isRequired,
  sellerLabelProviderId: PropTypes.number.isRequired,
});

export const CarrierSharingDataPropType = PropTypes.shape({
  isDefault: PropTypes.bool.isRequired,
  isRequired: PropTypes.bool.isRequired,
  selectedServices: PropTypes.arrayOf(SelectedServicePropType),
});

export const CarrierSharingCarriersPropType = PropTypes.shape({
  carrierId: PropTypes.string.isRequired,
  labelProviderId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

export const CarrierSharingLabelProvidersPropType = PropTypes.shape({
  labelProviderId: PropTypes.string.isRequired,
  name: PropTypes.string,
  sellerLabelProviderId: PropTypes.string.isRequired,
});

export const CarrierSharingActiveServicesPropType = PropTypes.shape({
  carrierId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  labelProviderId: PropTypes.string.isRequired,
});
